<template>
  <div>
              <v-col >
                <v-card >
                  <HostsItem />
                </v-card>
              </v-col>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
    import HostsItem from "@/components/HostsItem";

export default {
  components: {
        HostsItem
  },
  computed: {
  },
  methods: {
  },
  mounted() {
  },
  data: () => ({
    loading: false,
    settings: {},
  })
};
</script>

<style>
</style>